document.addEventListener('click',event=>{
  const link=event.target.closest('[data-parts-filter-link]');
  if(link){
    const target=new URL(link.href,location.origin);
    const params=new URLSearchParams(location.search);
    params.delete('page');
    params.delete('section_id');
    params.delete('sections');
    target.search=params.toString();
    link.href=target.href;
    return;
  }
  if(!event.target.closest('[data-parts-choice]'))document.querySelectorAll('[data-parts-choice][open]').forEach(item=>item.open=false);
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('[data-parts-choice][open]').forEach(item=>{item.open=false;item.querySelector('summary')?.focus()});
});
document.addEventListener('toggle',event=>{
  if(!event.target.matches?.('[data-parts-choice][open]'))return;
  document.querySelectorAll('[data-parts-choice][open]').forEach(item=>{if(item!==event.target)item.open=false});
},true);
